jQuery(function($) {
	/**
	 * create a clickable coursegroup list, as generated with shortcode [showcoursegroups]
	 */
	$(".coursegrouptitle").on("click", function() {
		// first close any desc section that is currently open
		$(".coursegroupdesc").hide();
		// find the next description and show it
		$(this).next(".coursegroupdesc").show();
	});
});